angular.module('core')
.controller('LoseSelectionsConfirmationModalController', ['$scope', '$modalInstance', function($scope, $modalInstance){
    $scope.yes = function() {
        $modalInstance.close();
    };

    $scope.no = function() {
        $modalInstance.dismiss('cancel');
    };
}]);
